import { PersonStamdata } from "../interfaces/stamdata";

export type StamdataPendingSection = "basis" | "interesser";

export const hasPendingStamdataSection = (
  stamdata: PersonStamdata,
  section: StamdataPendingSection,
): boolean => {
  if (!stamdata.harAktivStamdataAendring) return false;

  switch (section) {
    case "basis":
      return stamdata.harAktivStamdataAendringBasis === true;
    case "interesser":
      return stamdata.harAktivStamdataAendringInteresse === true;
  }
};
